export enum HubStatus {
	Starting,
	Info,
	Success,
	Error,
}

export const MessageTypes = {
	FundRegisterChecks: 'Register checks',
	FundChecksConfirmation: 'Checks Confirmation',
	FundAchConfirmation: 'ACH Confirmation',
	FundEftConfirmation: 'EFT Confirmation',
	FundAchReport: 'ACH Report',
	FundRegisterACH: 'Register ACH',
	FundAchFile: 'ACH File',
	HealthBenefitAccrual: 'Health Benefit Accrual',
	ProcessW2s: 'Process W2s',
	FYCreation: 'Fiscal Year Creation/Update',
	VoidChecks: 'Void Check(s)',
	VoidACHs: 'Void ACH(s)',
	PrintPrChecks: 'Print PR Checks',
	PublishEmployeeContracts: 'Publish Employee Contract PDFs',
	SendingEmployeeContracts: 'Sending Employee Contracts',
	CreditCardFileExport: 'Credit Card Export File',
	ProcessSummerPay: 'Process Summer Pay',
	Auth0UserMigration: 'Auth0 User Migration',
	ProcessEfts: 'Process EFTs',
};
